var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"errPage-container"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('h1',{staticClass:"text-jumbo text-ginormous"},[_vm._v("\n          Oops!\n        ")]),_c('h2',[_vm._v("NO AUTH")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }